import {AdvertCardTypeEnum} from "../Enums/AdvertCardTypeEnum";
import {AdvertCardItemClass, AdvertCardItemInterface} from "./AdvertCardItemInterface";

export interface AdvertCardInterface {
	title: string,
	type: AdvertCardTypeEnum,
	items: AdvertCardItemInterface[],
}

export class AdvertCardClass implements AdvertCardInterface {
	title = '';
	type = AdvertCardTypeEnum.VERTICAL_BIG;
	items = [new AdvertCardItemClass()];
}
